// src/components/hero/HeroFeatures.tsx
"use client";

// Package Imports
import React from "react";

// Style Imports
import styles from "./heroFeatures.module.scss";

const HeroFeatures: React.FC = () => {
  return (
    <section className={styles.heroFeatures}>
      <div className={styles.heroFeaturesInner}>
        <div className={styles.heroFeaturesContainer}>
          <div className={styles.heroFeatureItem}>
            <h3>24 Hour Turnaround Time</h3>
            <p>For in-stock items.</p>
          </div>
          <div className={styles.heroFeatureItem}>
            <h3>No Minimum Order Quantities</h3>
            <p>Order what you need, when you need it.</p>
          </div>
          <div className={styles.heroFeatureItem}>
            <h3>Fast, Reliable Shipping</h3>
            <p>Powered by FedEx delivery.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroFeatures;
